<template>
  <div class="cart-date-controls">
    <v-menu
      :value="showDialogCartDatePicker"
      :close-on-content-click="false"
      :nudge-right="40"
      transition="scale-transition"
      offset-y
      min-width="auto"
    >
      <template v-slot:activator="{ on, attrs }">
        <div class="my-3 pb-3">
          <v-row dense align="center">
            <v-col cols="2">
              <v-btn
                depressed
                tile
                @click="prevDay"
                :disabled="!searchDate"
                outlined
                class="mr-2 blue--text"
                block
                ><v-icon small>mdi-chevron-left</v-icon></v-btn
              >
            </v-col>
            <v-col>
              <v-text-field
                v-model="searchDate"
                label="Filter by Date"
                prepend-inner-icon="mdi-calendar"
                readonly
                clearable
                dense
                outlined
                hide-details
                v-bind="attrs"
                v-on="on"
                @click="showDialogCartDatePicker = true"
              />
            </v-col>
            <v-col cols="2">
              <v-btn
                depressed
                tile
                outlined
                class="mr-2 blue--text"
                @click="nextDay"
                :disabled="!searchDate"
                block
                ><v-icon small>mdi-chevron-right</v-icon></v-btn
              >
            </v-col>
          </v-row>
        </div>
      </template>
    </v-menu>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { mapFields } from 'vuex-map-fields'
import { parse, format } from 'date-fns'
import * as TimeFormats from '@/constants/TimeFormats'
import _get from 'lodash/get'
import _uniq from 'lodash/uniq'
import _reduce from 'lodash/reduce'
import _minBy from 'lodash/minBy'
import _maxBy from 'lodash/maxBy'

export default {
  name: 'CartDateControls',
  data() {
    return {}
  },
  mounted() {
    this.searchDate = null
  },
  methods: {
    prevDay() {
      if (this.nearestPastDate) {
        this.searchDate = format(this.nearestPastDate, TimeFormats.dateDashes)
      } else {
        let date = parse(this.searchDate, TimeFormats.dateDashes, new Date())
        this.searchDate = format(
          date.setDate(date.getDate() - 1),
          TimeFormats.dateDashes
        )
      }
    },
    nextDay() {
      if (this.nearestUpcomingDate) {
        this.searchDate = format(
          this.nearestUpcomingDate,
          TimeFormats.dateDashes
        )
      } else {
        let date = parse(this.searchDate, TimeFormats.dateDashes, new Date())
        this.searchDate = format(
          date.setDate(date.getDate() + 1),
          TimeFormats.dateDashes
        )
      }
    },
  },
  computed: {
    ...mapFields('cart', ['searchDate', 'showDialogCartDatePicker']),
    ...mapGetters('itemAndSection', ['getSections']),
    itemDates() {
      return _uniq(
        _reduce(
          this.sections,
          (dates, section) => [
            ...dates,
            ..._get(section, 'items', []).map((i) => i.date),
          ],
          []
        )
      )
    }, // itemDates
    sections() {
      return this.getSections
    }, // sections

    nearestPastDate() {
      let date = parse(this.searchDate, TimeFormats.dateDashes, new Date())
      let pastDates = this.itemDates.filter((d) => {
        let itemDate = parse(d, TimeFormats.dateDashes, new Date())
        return itemDate < date
      })
      let nearestPastDate =
        _maxBy(pastDates, (d) => {
          let itemDate = parse(d, TimeFormats.dateDashes, new Date())
          return itemDate
        }) ?? null
      return nearestPastDate
        ? parse(nearestPastDate, TimeFormats.dateDashes, new Date())
        : null
    }, // nearestPastDate

    nearestUpcomingDate() {
      let date = parse(this.searchDate, TimeFormats.dateDashes, new Date())
      let upcomingDates = this.itemDates.filter((d) => {
        let itemDate = parse(d, TimeFormats.dateDashes, new Date())
        return itemDate > date
      })
      let nearestUpcomingDate = _minBy(upcomingDates, (d) => {
        let itemDate = parse(d, TimeFormats.dateDashes, new Date())
        return itemDate
      })

      return nearestUpcomingDate
        ? parse(nearestUpcomingDate, TimeFormats.dateDashes, new Date())
        : null
    }, // nearestUpcomingDate
  },
}
</script>
